module.exports = __webpack_public_path__ + "img/dimension-bg2.7380ed4c.png";